<div class="body">
    <br />

    <br />
    <div class="row" *ngIf="afiliado.estadoAfiliado">
        <div class="col-lg-1"></div>

        <div class="col-lg-3"> <label> Estado Afiliación</label> </div>

        <div class="col-lg-5">
            <input id="estadoAfiliado" name="estadoAfiliado" class="form-control" [disabled]="afiliado.deshabilitado"
                [(ngModel)]="afiliado.estadoAfiliado" type="text">
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Fecha Afiliación</label> </div>

        <div class="col-lg-5">
            <input id="fechaAfiliacion" name="fechaAfiliacion" class="form-control" [disabled]="afiliado.fechaDeshabilitada"
                [(ngModel)]="afiliado.fechaAfiliacion" matInput type="date" placeholder="fecha Afiliacion." />

        </div>
    </div>

    <br />
    <div class="row" *ngIf="afiliado.isAdmin && afiliado.estadoAfiliado =='DESAFILIADO' && !(rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO')">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Fecha Desafiliación </label> </div>

        <div class="col-lg-5">
            <input id="fechaDesafiliacion" name="fechaDesafiliacion" class="form-control"
                [(ngModel)]="afiliado.fechaDesafiliacion" matInput type="date" placeholder="fecha Desafiliacion." />

        </div>
    </div>

    <br />
    <br />

    <div class="row" *ngIf="afiliado.isAdmin && afiliado.estadoAfiliado =='PENDIENTE_AFILIACION' && !(rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO')">
        <div class="col-lg-1"></div>

        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida"
                (click)="aprobarSolicitud(afiliado.rut,afiliado.fechaAfiliacion)">
                Aprobar Solicitud
            </button>
        </div>
        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida" (click)="rechazarSolicitud(afiliado.rut)">
                Rechazar Solicitud
            </button>
        </div>
    </div>

    <div class="row" *ngIf="afiliado.isAdmin && (afiliado.estadoAfiliado =='DESAFILIADO' || afiliado.estadoAfiliado =='RECHAZAR_AFILIACION') && !(rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO')">
        <div class="col-lg-1"></div>

        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida"
                (click)="afiliarFuncionario(afiliado.rut,afiliado.fechaAfiliacion)">
                 Afiliar
            </button>
        </div>      
    </div>



    <div class="row" *ngIf="afiliado.isAdmin  && afiliado.estadoAfiliado =='AFILIADO' && !(rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO')">
        <div class="col-lg-3"></div>

        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida" (click)="desafiliarAfiliado(afiliado.rut)">
                Desafiliar
            </button>
        </div>
        <div class="col-lg-3"  *ngIf="afiliado.isAdmin  && afiliado.tipoAfiliado!='PASIVO' &&  afiliado.estadoAfiliado =='AFILIADO' && (rol == 'ROLE_ADMINISTRADOR')">
            <button class="btn btn-success" id="btnvalida" (click)="afiliadoPensionado(afiliado.rut,afiliado.fechaAfiliacion,afiliado.id)">
                Afiliado Pensionado
            </button>
         </div>
       
    </div>   
   
    <div class="row" *ngIf="afiliado.estadoAfiliado =='AFILIADO' && (rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO')">
        <div class="col-lg-1"></div>

        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida" (click)="solicitarDesafiliarAfiliado(afiliado.rut)">
                Solicitar Desafiliar
            </button>
        </div>
    </div>
    <div class="row" *ngIf="afiliado.isAdmin &&  afiliado.estadoAfiliado =='PENDIENTE_DESAFILIACION' && !(rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO')">
        <div class="col-lg-1"></div>

        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida" (click)="desafiliarAfiliado(afiliado.rut)">
                Confirmar Desafiliación
            </button>
        </div>

        <div class="col-lg-3">
            <button class="btn btn-success" id="btnvalida" (click)="rechazarDesafiliacion(afiliado.rut,afiliado.fechaAfiliacion)">
                Rechazar Desafiliación
            </button>
        </div>

    </div>
    <br />

</div>